import React, { lazy, Suspense, useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { ADMIN_API } from "./common/common";
import { canBypassAgMaintenance, checkSettingOption, settingAccess } from "./common/settingsAccess";
import { Logout } from "./common/Funcation";
import { prefetchAdminSite } from "./common/prefetchAdminSite";
import ImageUpload from "./components/ImageUpload";
import Loader from "./components/Loader";
import PrivateRoute, { RolePendingContext } from "./PrivateRoute";
import AddEdit from "./pages/banking/method/AddEdit";
import BankingMethod from "./pages/banking/method/BankingMethod";
import ChangePassword from "./pages/ChangePassword";
import DWReport from "./pages/MyReport/DWReport";
import NotFound from "./pages/NotFound";
import Deposit from "./pages/Payment/Deposit";
import Withdraw from "./pages/Payment/Withdraw";
import RiskManagementDetail from "./pages/RiskManagement/component/RiskManagementDetail";
import RiskBetDetailsPopup from "./pages/RiskManagement/component/RiskBetDetailsPopup";
import RiskDownlinePLPopup from "./pages/RiskManagement/component/RiskDownlinePLPopup";
import RiskPlayerBetsPopup from "./pages/RiskManagement/component/RiskPlayerBetsPopup";
import RiskFancyRunPositionPopup from "./pages/RiskManagement/component/RiskFancyRunPositionPopup";
import EditDashBanner from "./pages/Setting/Edit/EditDashBanner";
import EditDashBoard from "./pages/Setting/Edit/EditDashBoard";
import EditWebsites from "./pages/Setting/Edit/EditWebsites";
import MangeFancy from "./pages/Setting/Edit/MangeFancy";
import MangePremium from "./pages/Setting/Edit/MangePremium";
import ManageBanner from "./pages/Setting/ManageBanner";
import ManageCasino from "./pages/Setting/ManageCasino";
import ManageDashboard from "./pages/Setting/ManageDashboard";
import ManageWebsites from "./pages/Setting/ManageWebsites";
import PremiumDeclare from "./pages/Setting/PremiumDeclare";
import PremiumHistory from "./pages/Setting/PremiumHistory";
import SessionDeclare from "./pages/Setting/SessionDeclare";
import SessionHistory from "./pages/Setting/SessionHistory";
import WinnerHistory from "./pages/Setting/WinnerHistory";
import PublicRoute from "./PublicRoute";
import { getApi, sendEvent, socketConnect } from "./service";
import MatchProfitLoss from "./pages/MyReport/MatchProfitLoss";
import SABADownline from "./pages/MyReport/SABADownline";
import ProviderPL from "./pages/MyReport/ProviderPL";
import ShowBetsCR from "./pages/MyReport/ShowBetsCR";
import SportsSettings from "./pages/AdminSetting/SportsSettings";
import Login from "./pages/Login";
import Maintenance from "./pages/Maintenance";
import PlayerBanking from "./pages/banking/PlayerBanking";
import AgentBanking from "./pages/banking/AgentBanking";
// import Home from './pages/Home'
const Home = lazy(() => import("./pages/Home"));
const MyAccount = lazy(() => import("./pages/MyAccount"));
const LossDownLine = lazy(() => import("./pages/MyReport/LossDownlineNew"));
const LossCasino = lazy(() => import("./pages/MyReport/LossCasino"));
const LossMarket = lazy(() => import("./pages/MyReport/LossMarket"));
const AccountStatement = lazy(
  () => import("./pages/MyReport/AccountStatement")
);
const BetLive = lazy(() => import("./pages/BetLive/BetLive"));
const BetList = lazy(() => import("./pages/BetList/BetList"));
const RiskManagement = lazy(
  () => import("./pages/RiskManagement/RiskManagement")
);
const MasterBanking = lazy(() => import("./pages/banking/MasterBanking"));

const SportLegue = lazy(() => import("./pages/SportLegue/SportLegue"));
const MainMarket = lazy(() => import("./pages/Setting/MainMarket"));
const BlockMarket = lazy(() => import("./pages/BlockMarket/BlockMarket"));
const BlockMarketList = lazy(() => import("./pages/BlockMarket/BlockMarketList"));
const AddMatch = lazy(() => import("./pages/AddMatch/AddMatch"));
const AdminSetting = lazy(() => import("./pages/AdminSetting/AdminSetting"));
const Asearchusers = lazy(() => import("./pages/AdminSetting/Asearchusers"));
const AWebsiteSetting = lazy(
  () => import("./pages/AdminSetting/AWebsiteSetting")
);
const AAddWebsiteSetting = lazy(
  () => import("./pages/AdminSetting/AAddWebsiteSetting")
);
const AManageLinks = lazy(() => import("./pages/AdminSetting/AManageLinks"));
const GameUsersList = lazy(() => import("./pages/AdminSetting/gameUsersList"));
const Asurveillance = lazy(() => import("./pages/AdminSetting/Asurveillance"));
const MonitorUserPnL = lazy(
  () => import("./pages/AdminSetting/monitorUserPnL")
);
const Prematchpl = lazy(() => import("./pages/AdminSetting/prematchpl"));
const Prematchuserbet = lazy(
  () => import("./pages/AdminSetting/prematchuserbet")
);
const AMasterCheat = lazy(() => import("./pages/AdminSetting/AMasterCheat"));
const ACheatIps = lazy(() => import("./pages/AdminSetting/ACheatIps"));
const AsameIpUsers = lazy(() => import("./pages/AdminSetting/AsameIpUsers"));
const AliveMatchbets = lazy(
  () => import("./pages/AdminSetting/AliveMatchbets")
);
const AbetCount = lazy(() => import("./pages/AdminSetting/AbetCount"));
const AbetLockUsers = lazy(() => import("./pages/AdminSetting/AbetLockUsers"));
const AactiveMatch = lazy(() => import("./pages/AdminSetting/AactiveMatch"));
const WhiteLimit = lazy(() => import("./pages/AdminSetting/WhiteLimit"));
const AinactiveMatch = lazy(
  () => import("./pages/AdminSetting/AinactiveMatch")
);
const AdeletedBets = lazy(() => import("./pages/AdminSetting/AdeletedBets"));
const AupdateFancyStatus = lazy(
  () => import("./pages/AdminSetting/AupdateFancyStatus")
);
const AsuspendedResults = lazy(
  () => import("./pages/AdminSetting/AsuspendedResults")
);
const AUserMessage = lazy(() => import("./pages/AdminSetting/AUserMessage"));
const AHyperMessage = lazy(() => import("./pages/AdminSetting/AHyperMessage"));
const AImpMessage = lazy(() => import("./pages/AdminSetting/AImpMessage"));
const AImageAdd = lazy(() => import("./pages/AdminSetting/AImageAdd"));
const AdeletedUsers = lazy(() => import("./pages/AdminSetting/AdeletedUsers"));
const AsuspendedfancyResult = lazy(
  () => import("./pages/AdminSetting/AsuspendedfancyResult")
);
const AsuspendedmarketResult = lazy(
  () => import("./pages/AdminSetting/AsuspendedmarketResult")
);
const ADeafultSetting = lazy(
  () => import("./pages/AdminSetting/ADeafultSetting")
);
const DeafultContactSetting = lazy(
  () => import("./pages/AdminSetting/DeafultContactSetting")
);
const P2PSetting = lazy(() => import("./pages/AdminSetting/P2PSetting"));
const AsetResult = lazy(() => import("./pages/results/AsetResult"));
const ASetMarketResult = lazy(() => import("./pages/results/ASetMarketResult"));
const ASetFancyResult = lazy(() => import("./pages/results/ASetFancyResult"));
const Achecksportwiseresult = lazy(
  () => import("./pages/old-res/Achecksportwiseresult")
);
const Atransactionlist = lazy(() => import("./pages/dw-req/Atransactionlist"));
const AtransactionlistWithdrawl = lazy(
  () => import("./pages/dw-req/AtransactionlistWithdrawl")
);
const PrivilegesRoles = lazy(() => import("./pages/PrivilegesRoles"));
const Ariskmanagement = lazy(
  () => import("./pages/risk-management/Ariskmanagement")
);
const ACasRiskMgmt = lazy(() => import("./pages/risk-management/ACasRiskMgmt"));
const ExposureCalc = lazy(() => import("./pages/ExposureCalc"));
const OpsCenter = lazy(() => import("./pages/OpsCenter"));
const UpdateUser = lazy(() => import("./pages/AdminSetting/UpdateUser"));
const Analytics = lazy(() => import("./pages/Analytics/Analytics"));
const SbkashHistory = lazy(() => import("./pages/Payment/SbkashDeposits"));

const AG_MAINTENANCE_ALLOW_PATHS = ["/maintenance", "/change/password"];

function hasRolePayload(role: any) {
  return Boolean(
    role &&
      (role.name ||
        role.user_name ||
        role.player_banking != null ||
        role.agent_banking != null),
  );
}

/** First page this role can open. Missing flags stay allowed. Never returns /404. */
function landingPath(role: any) {
  if (!role || role.downline_list !== 0) return "/";
  const options: Array<[string, string]> = [
    ["my_account", "/profile"],
    ["bet_list", "/betList"],
    ["bet_list_live", "/bet-live"],
    ["market_report", "/loss/market"],
    ["downline_report", "/loss/down-line"],
    ["account_statement", "/account/statement"],
    ["risk_management", "/risk-management"],
    ["agent_banking", "/agent/banking"],
    ["player_banking", "/player/banking"],
    ["match_history", "/session/cricket/history"],
    ["manage_fancy", "/session/cricket/declare"],
  ];
  for (const [key, path] of options) {
    if (role[key] !== 0) return path;
  }
  return "";
}

function HomeRoute({ routeData }: { routeData: any }) {
  const headerRole = useSelector((e: any) => e.Header);
  const rolePending = useContext(RolePendingContext);
  const role = hasRolePayload(routeData)
    ? routeData
    : hasRolePayload(headerRole)
      ? headerRole
      : null;

  if (!role && rolePending) {
    return (
      <PrivateRoute pending hasAccess={1}>
        <Loader />
      </PrivateRoute>
    );
  }
  if (role?.downline_list === 0) {
    const next = landingPath(role);
    if (next) return <Navigate to={next} replace />;
    return (
      <PrivateRoute hasAccess={1}>
        <div className="container dashboard_main" style={{ padding: 24 }}>
          No page is enabled for this account. Ask the upline to turn on a menu.
        </div>
      </PrivateRoute>
    );
  }
  return (
    <PrivateRoute hasAccess={1}>
      <Home />
    </PrivateRoute>
  );
}

/** Open the banking page this role is allowed to use. A missing flag stays allowed, same as before. */
function BankingRoute({
  routeData,
  ownKey,
  otherKey,
  otherPath,
  children,
}: {
  routeData: any;
  ownKey: "player_banking" | "agent_banking";
  otherKey: "player_banking" | "agent_banking";
  otherPath: string;
  children: React.ReactNode;
}) {
  const headerRole = useSelector((e: any) => e.Header);
  const rolePending = useContext(RolePendingContext);
  // Login already stored the role in redux. getRole can fail or finish
  // without writing routeData; waiting on `routeData === undefined` left
  // this loader up forever. Refresh worked because getRole ran again.
  const role = hasRolePayload(routeData)
    ? routeData
    : hasRolePayload(headerRole)
      ? headerRole
      : undefined;

  if (!role && rolePending) {
    return (
      <PrivateRoute pending hasAccess={1}>
        {children}
      </PrivateRoute>
    );
  }

  const own = role?.[ownKey];
  // pending={false} so a later getRole retry cannot unmount this page
  // and throw away the list request that is already in flight.
  if (own) {
    return (
      <PrivateRoute pending={false} hasAccess={1}>
        {children}
      </PrivateRoute>
    );
  }
  if (own === 0 && role?.[otherKey]) {
    return (
      <PrivateRoute pending={false} hasAccess={1}>
        <Navigate to={otherPath} replace />
      </PrivateRoute>
    );
  }
  return (
    <PrivateRoute pending={false} hasAccess={own === 0 ? 0 : 1}>
      {children}
    </PrivateRoute>
  );
}

const cookies = new Cookies();
const Router = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector((e: any) => e.userData);
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const HeaderData = useSelector((e: any) => e.Header);
  const DD = useSelector((e: any) => e.domainDetails);
  const [routeData, setRouteData] = useState<any>();
  const [roleReady, setRoleReady] = useState(() => !cookies.get("skyToken"));
  const roleRequestRef = useRef(0);
  useEffect(() => {
    const authToken = cookies.get("skyToken");
    if (authToken) {
      // Login already stored role permissions. Keep the page up and refresh
      // getRole in the background. A full reload still has no role, so it waits.
      if (hasRolePayload(HeaderData)) {
        setRouteData((current: any) => {
          const sameUser =
            hasRolePayload(current) &&
            current.user_name &&
            HeaderData.user_name &&
            current.user_name === HeaderData.user_name;
          return sameUser ? current : HeaderData;
        });
        setRoleReady(true);
      } else {
        setRoleReady(false);
      }
      getHeaderDetails();
    } else {
      setRouteData(undefined);
      setRoleReady(true);
    }
    socketConnect(dispatch, (flag: any) => {
      if (flag) {
        if (authToken && HeaderData) {
          setTimeout(() => {
            sendEvent("SIGN_UP_ADMIN", { userId: HeaderData?.user_name });
          }, 500);

          setTimeout(() => {
            sendEvent("VERIFY_TOKEN_ADMIN", {
              userId: HeaderData?._id,
              token: authToken,
            });
          }, 700);
        }
      }
    });
    prefetchAdminSite(dispatch);
    return () => {};
  }, [cookies.get("skyToken")]);

  useEffect(() => {
    if (!isAuthenticated?.isLogin || isAuthenticated?.changePassword !== true) {
      return;
    }
    const path = location.pathname.toLowerCase();
    if (path === "/change/password" || path === "/maintenance") return;
    navigate("/change/password", { replace: true });
  }, [isAuthenticated, location.pathname, navigate]);

  useEffect(() => {
    if (!DD?.isAgMaintenance) return;
    const path = location.pathname.toLowerCase();
    if (AG_MAINTENANCE_ALLOW_PATHS.includes(path)) return;
    const authToken = cookies.get("skyToken");
    if (authToken && !HeaderData?.name) return;
    if (canBypassAgMaintenance(HeaderData?.name)) return;
    navigate("/maintenance", { replace: true });
  }, [DD, HeaderData, location.pathname, navigate]);

  const getHeaderDetails = async () => {
    const requestId = ++roleRequestRef.current;
    let data = {
      api: ADMIN_API.GET_ROLE,
      value: {},
    };
    try {
      const response = await getApi(data);
      if (requestId !== roleRequestRef.current) return;
      const nextRole = response?.data?.data;
      if (nextRole) {
        setRouteData(nextRole);
        dispatch({ type: "HEADER_DETAILS", payload: nextRole });
      }
    } catch (err: any) {
      if (requestId !== roleRequestRef.current) return;
      const statusCode =
        err?.response?.data?.statusCode ?? err?.response?.status;
      if (statusCode === 401) {
        dispatch({ type: "LOGOUT" });
        Logout();
        navigate("/login");
      }
    } finally {
      if (requestId === roleRequestRef.current) {
        setRoleReady(true);
      }
    }
  };

  const allow = (
    existing: any,
    opts?: { wlFlag?: string; wlFlags?: string[]; common?: boolean; result?: boolean }
  ) => settingAccess(routeData, existing, opts);
  const websiteFlag =
    routeData?.all_website_setting !== undefined &&
    routeData?.all_website_setting !== null
      ? routeData.all_website_setting
      : routeData?.manage_website;

  return (
    <RolePendingContext.Provider value={!roleReady}>
      <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path={`/`}
          element={<HomeRoute routeData={routeData} />}
        />
        <Route
          path={`/login`}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={`/maintenance`}
          element={<Maintenance />}
        />
        <Route
          path={`/change/password`}
          element={
            <PublicRoute>
              <ChangePassword />
            </PublicRoute>
          }
        />
        <Route
          path={`/profile`}
          element={
            <PrivateRoute hasAccess={routeData?.my_account}>
              <MyAccount />
            </PrivateRoute>
          }
        >
          <Route
            path={`:tab/`}
            element={
              <PrivateRoute hasAccess={routeData?.my_account}>
                <MyAccount />
              </PrivateRoute>
            }
          />
          <Route
            path={`/profile`}
            element={
              <PrivateRoute hasAccess={routeData?.my_account}>
                <MyAccount />
              </PrivateRoute>
            }
          />
        </Route>
        <Route
          path={`/user/:tab/:TYPE/:userId`}
          element={
            <PrivateRoute hasAccess={routeData?.my_account}>
              <MyAccount />
            </PrivateRoute>
          }
        />
        <Route
          path={`/user/:tab/:TYPE/:userId/`}
          element={
            <PrivateRoute hasAccess={routeData?.my_account}>
              <MyAccount />
            </PrivateRoute>
          }
        />
        <Route
          path={`/loss/down-line`}
          element={
            <PrivateRoute hasAccess={routeData?.downline_report}>
              <LossDownLine />
            </PrivateRoute>
          }
        />
        <Route
          path={`/loss/casino`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.casinoReport || routeData?.casinoReport !== 0
              }
            >
              <LossCasino />
            </PrivateRoute>
          }
        />
        <Route
          path={`/loss/market`}
          element={
            <PrivateRoute hasAccess={routeData?.market_report}>
              <LossMarket />
            </PrivateRoute>
          }
        />
        <Route
          path={`/report/DW`}
          element={
            <PrivateRoute hasAccess={1}>
              <DWReport />
            </PrivateRoute>
          }
        />
        <Route
          path={`/loss/match`}
          element={
            <PrivateRoute hasAccess={1}>
              <MatchProfitLoss />
            </PrivateRoute>
          }
        />
        <Route
          path={`/loss/saba`}
          element={
            <PrivateRoute hasAccess={1}>
              <SABADownline />
            </PrivateRoute>
          }
        />
        <Route
          path={`/showProviderPL`}
          element={
            <PrivateRoute hasAccess={1}>
              <ProviderPL />
            </PrivateRoute>
          }
        />
        <Route
          path={`/showBetsCR/admin/:id`}
          element={
            <PrivateRoute hasAccess={1}>
              <ShowBetsCR />
            </PrivateRoute>
          }
        />
        <Route
          path={`/account/statement`}
          element={
            <PrivateRoute hasAccess={routeData?.account_statement}>
              <AccountStatement />
            </PrivateRoute>
          }
        />
        <Route
          path={`/bet-live`}
          element={
            <PrivateRoute hasAccess={routeData?.bet_list_live}>
              <BetLive />
            </PrivateRoute>
          }
        />
        <Route
          path={`/betList`}
          element={
            <PrivateRoute hasAccess={routeData?.bet_list}>
              <BetList />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-management`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={`/block-market`}
          element={
            <PrivateRoute hasAccess={routeData?.marketBlock}>
              <BlockMarket />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AblockMarketlist/:id`}
          element={
            <PrivateRoute hasAccess={routeData?.marketBlock}>
              <BlockMarketList />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-management-detail/:id`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskManagementDetail />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-bet-details`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskBetDetailsPopup />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-downline-pl`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskDownlinePLPopup />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-player-bets`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskPlayerBetsPopup />
            </PrivateRoute>
          }
        />
        <Route
          path={`/risk-fancy-run-position`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <RiskFancyRunPositionPopup />
            </PrivateRoute>
          }
        />
        <Route
          path={`/master/banking`}
          element={
            <PrivateRoute hasAccess={routeData?.add_balance}>
              <MasterBanking />
            </PrivateRoute>
          }
        />
        <Route
          path={`/player/banking`}
          element={
            <BankingRoute
              routeData={routeData}
              ownKey="player_banking"
              otherKey="agent_banking"
              otherPath="/agent/banking"
            >
              <PlayerBanking />
            </BankingRoute>
          }
        />
        <Route
          path={`/agent/banking`}
          element={
            <BankingRoute
              routeData={routeData}
              ownKey="agent_banking"
              otherKey="player_banking"
              otherPath="/player/banking"
            >
              <AgentBanking />
            </BankingRoute>
          }
        />
        <Route
          path={`/bankingMethod`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.bankingMethod ||
                routeData?.bankingMethod === undefined
              }
            >
              <BankingMethod />
            </PrivateRoute>
          }
        />
        <Route
          path={`/add-bankingMethod`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.bankingMethod ||
                routeData?.bankingMethod === undefined
              }
            >
              <AddEdit />
            </PrivateRoute>
          }
        />
        <Route
          path={`/edit-bankingMethod/:id`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.bankingMethod ||
                routeData?.bankingMethod === undefined
              }
            >
              <AddEdit />
            </PrivateRoute>
          }
        />
        <Route
          path={`/sport-league`}
          element={
            <PrivateRoute hasAccess={routeData?.sports_leage}>
              <SportLegue />
            </PrivateRoute>
          }
        />
        <Route
          path={`/main-market`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.sports_main_market, { common: true })}>
              <MainMarket />
            </PrivateRoute>
          }
        />
        <Route
          path={`/winner/cricket/history`}
          element={
            <PrivateRoute hasAccess={routeData?.match_history}>
              <WinnerHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={`/session/cricket/declare`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_fancy, { result: true })}>
              <SessionDeclare />
            </PrivateRoute>
          }
        />
        <Route
          path={`/session/cricket/history`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.fancy_history, { result: true })}>
              <SessionHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={`/session/bets/history/:id/:type`}
          element={
            <PrivateRoute hasAccess={allow(1, { result: true })}>
              <MangeFancy />
            </PrivateRoute>
          }
        />
        <Route
          path={`/cricket/premium/declare`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_premium, { result: true })}>
              <PremiumDeclare />
            </PrivateRoute>
          }
        />
        <Route
          path={`/cricket/premium/history`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.premium_history, { result: true })}>
              <PremiumHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={`/cricket/bets/declare/:id/:type`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_premium ?? 1, { result: true })}>
              <MangePremium />
            </PrivateRoute>
          }
        />
        <Route
          path={`/website`}
          element={
            <PrivateRoute hasAccess={allow(websiteFlag, { common: true })}>
              <ManageWebsites />
            </PrivateRoute>
          }
        />
        <Route
          path={`/add-website`}
          element={
            <PrivateRoute hasAccess={allow(websiteFlag, { common: true })}>
              <EditWebsites />
            </PrivateRoute>
          }
        />
        <Route
          path={`/edit-website/:id`}
          element={
            <PrivateRoute hasAccess={allow(websiteFlag, { common: true })}>
              <EditWebsites />
            </PrivateRoute>
          }
        />
        <Route
          path={`/casino`}
          element={
            <PrivateRoute hasAccess={routeData?.casino_manage}>
              <ManageCasino />
            </PrivateRoute>
          }
        />
        <Route
          path={`/dashboard-images`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_dashboard_images, { common: true })}>
              <ManageDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={`/edit-dashboard/:id`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_dashboard_images, { common: true })}>
              <EditDashBoard />
            </PrivateRoute>
          }
        />
        <Route
          path={`/add-dashboard/:id`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_dashboard_images, { common: true })}>
              <EditDashBoard />
            </PrivateRoute>
          }
        />
        <Route
          path={`/upload`}
          element={
            <PrivateRoute hasAccess={1}>
              <ImageUpload />
            </PrivateRoute>
          }
        />
        <Route
          path={`/payment/deposit`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.onlinePaymentDeposite ||
                routeData?.onlinePaymentDeposite !== 0
              }
            >
              <Deposit />
            </PrivateRoute>
          }
        />
        <Route
          path={`/payment/withdraw`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.onlinePaymentWithdrawals ||
                routeData?.onlinePaymentWithdrawals !== 0
              }
            >
              <Withdraw />
            </PrivateRoute>
          }
        />
        <Route
          path={`/payment/sbkash`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.onlinePaymentDeposite ||
                routeData?.onlinePaymentDeposite !== 0
              }
            >
              <SbkashHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={`/banner`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.banner, { common: true })}>
              <ManageBanner />
            </PrivateRoute>
          }
        />
        <Route
          path={`/edit-banner/:id`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.banner, { common: true })}>
              <EditDashBanner />
            </PrivateRoute>
          }
        />
        <Route
          path={`/add-banner/:id`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.banner, { common: true })}>
              <EditDashBanner />
            </PrivateRoute>
          }
        />
        <Route
          path={`/add-match`}
          element={
            <PrivateRoute hasAccess={routeData?.sports_leage || routeData?.site_match}>
              <AddMatch />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AdminSetting`}
          element={
            <PrivateRoute hasAccess={checkSettingOption(routeData)}>
              <AdminSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Asearchusers`}
          element={
            <PrivateRoute hasAccess={true}>
              <Asearchusers />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AWebsiteSetting`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_website" })}>
              <AWebsiteSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AAddWebsiteSetting`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_website" })}>
              <AAddWebsiteSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AManageLinks`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_website" })}>
              <AManageLinks />
            </PrivateRoute>
          }
        />
        <Route
          path={`/gameUsersList`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_concurrent" })}>
              <GameUsersList />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Asurveillance`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.surveillance, { wlFlag: "as_surveillance" })}>
              <Asurveillance />
            </PrivateRoute>
          }
        />
        <Route
          path={`/MonitorUserPnL`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <MonitorUserPnL />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Prematchpl`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <Prematchpl />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Prematchuserbet/:id`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <Prematchuserbet />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AMasterCheat`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <AMasterCheat />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ACheatIps`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <ACheatIps />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AsameIpUsers`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <AsameIpUsers />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AliveMatchbets`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <AliveMatchbets />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AbetCount`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_surveillance" })}>
              <AbetCount />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AbetLockUsers`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlags: ["as_user_settings", "as_surveillance"] })}>
              <AbetLockUsers />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AactiveMatch`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.sports_main_market, { wlFlag: "as_match_bets" })}>
              <AactiveMatch />
            </PrivateRoute>
          }
        />
        <Route
          path={`/WhiteLimit`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.whiteLablesCasinoLimit, { wlFlag: "as_white_limit" })}>
              <WhiteLimit />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AinactiveMatch`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.sports_main_market, { wlFlag: "as_match_bets" })}>
              <AinactiveMatch />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AdeletedBets`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.bet_list, { wlFlag: "as_match_bets" })}>
              <AdeletedBets />
            </PrivateRoute>
          }
        />
        <Route
          path={`/exposure-calc`}
          element={
            <PrivateRoute hasAccess={1}>
              <ExposureCalc />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ops`}
          element={
            <PrivateRoute hasAccess={1}>
              <OpsCenter />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AupdateFancyStatus`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_fancy, { wlFlag: "as_match_bets" })}>
              <AupdateFancyStatus />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AsuspendedResults`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.fancy_history, { wlFlag: "as_match_bets" })}>
              <AsuspendedResults />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AUserMessage`}
          element={
            <PrivateRoute hasAccess={routeData?.name === "WL" || routeData?.manage_website ? 1 : 0}>
              <AUserMessage />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AHyperMessage`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_messages" })}>
              <AHyperMessage />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AImpMessage`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_messages" })}>
              <AImpMessage />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AImageAdd`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_website, { wlFlag: "as_messages" })}>
              <AImageAdd />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AdeletedUsers`}
          element={
            <PrivateRoute hasAccess={allow(1, { wlFlag: "as_user_settings" })}>
              <AdeletedUsers />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AsuspendedfancyResult`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_fancy, { wlFlag: "as_match_bets" })}>
              <AsuspendedfancyResult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AsuspendedmarketResult`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.match_history, { wlFlag: "as_match_bets" })}>
              <AsuspendedmarketResult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ADeafultSetting`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.name === "SUO" ||
                routeData?.name === "WL" ||
                routeData?.manage_website
                  ? 1
                  : 0
              }
            >
              <ADeafultSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/DeafultContactSetting`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.default_settings ?? 1, { common: true })}>
              <DeafultContactSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/P2PSetting`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.p2pSettings, { wlFlag: "as_p2p" })}>
              <P2PSetting />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AsetResult`}
          element={
            <PrivateRoute hasAccess={allow(1, { result: true })}>
              <AsetResult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ASetMarketResult`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.sports_main_market, { result: true })}>
              <ASetMarketResult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ASetFancyResult`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.manage_fancy, { result: true })}>
              <ASetFancyResult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Achecksportwiseresult`}
          element={
            <PrivateRoute hasAccess={true}>
              <Achecksportwiseresult />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Atransactionlist`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.onlinePaymentWithdrawals ||
                routeData?.onlinePaymentDeposite
              }
            >
              <Atransactionlist />
            </PrivateRoute>
          }
        />
        <Route
          path={`/AtransactionlistWithdrawl`}
          element={
            <PrivateRoute
              hasAccess={
                routeData?.onlinePaymentWithdrawals ||
                routeData?.onlinePaymentDeposite
              }
            >
              <AtransactionlistWithdrawl />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Ariskmanagement`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <Ariskmanagement />
            </PrivateRoute>
          }
        />
        <Route
          path={`/ACasRiskMgmt`}
          element={
            <PrivateRoute hasAccess={routeData?.risk_management}>
              <ACasRiskMgmt />
            </PrivateRoute>
          }
        />
        <Route
          path={`/Privileges`}
          element={
            <PrivateRoute hasAccess={routeData?.privileges}>
              <PrivilegesRoles />
            </PrivateRoute>
          }
        />
        <Route
          path={`/update-user`}
          element={
            <PrivateRoute hasAccess={1}>
              <UpdateUser />
            </PrivateRoute>
          }
        />
        <Route
          path={`/analytics`}
          element={
            <PrivateRoute hasAccess={1}>
              <Analytics />
            </PrivateRoute>
          }
        />
        <Route
          path={`/sport-settings`}
          element={
            <PrivateRoute hasAccess={allow(routeData?.sportSettings ?? 1, { common: true })}>
              <SportsSettings />
            </PrivateRoute>
          }
        />
        <Route
          path={`/*`}
          element={
            <PrivateRoute hasAccess={1}>
              <NotFound />
            </PrivateRoute>
          }
        />
      </Routes>
      </Suspense>
    </RolePendingContext.Provider>
  );
};

export default Router;
